import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  brandFonts,
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  visuallyHidden,
} from '../styles';
import { Image, Button, Link } from './ui';
import { formatPrice } from '../utils';

const StyledMegaMenuSpaCta = styled.article`
  ${maxBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.mlarge`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;
    padding: 30px;
    background-color: ${brandColours.senary};
  `}
`;

const StyledHeading = styled.p`
  ${minBreakpointQuery.mlarge`
    font-weight: ${fontWeights.bold};
    ${fontSize(18)};
  `}

  strong {
    ${minBreakpointQuery.mlarge`
      font-weight: inherit;
    `}
  }
`;

const StyledInner = styled.div``;

const StyledImage = styled(Image)`
  ${minBreakpointQuery.mlarge`
    margin-bottom: 16px;
    border-radius: 15px;
  `}
`;

const StyledLocation = styled.span`
  ${minBreakpointQuery.mlarge`
    display: block;
    margin-bottom: 6px;
    color: ${brandColours.quinary};
    font-weight: ${fontWeights.medium};
    ${fontSize(14)};
  `}
`;

const StyledName = styled.p`
  ${minBreakpointQuery.mlarge`
    ${brandFonts.secondary};
    ${fontSize(25)};
    line-height: 1.2;
  `}
`;

const StyledPrice = styled.span`
  ${minBreakpointQuery.mlarge`
    display: block;
    margin-top: 10px;
    font-weight: ${fontWeights.medium};
    ${fontSize(14)};
  `}

  span {
    ${minBreakpointQuery.mlarge`
      ${fontSize(22)};
    `}
  }
`;

const StyledButton = styled(Button)`
  ${minBreakpointQuery.mlarge`
    margin-top: 14px;
    width: 100%;
  `}
`;

const MegaMenuSpaCta = ({
  name,
  images,
  city,
  county,
  minPrice,
  isPricePerPerson,
  url,
}) => (
  <StyledMegaMenuSpaCta>
    <StyledHeading>
      <strong>Spa of the Week</strong>
    </StyledHeading>
    <StyledInner>
      <StyledImage
        src={images[0].url}
        alt={images[0].title}
        width={260}
        height={125}
        layout="constrained"
      />
      <StyledLocation>
        {city}, {county.name}
      </StyledLocation>
      <StyledName>
        <Link to={url}>{name}</Link>
      </StyledName>
      <StyledPrice>
        From <span>{formatPrice(minPrice)}</span> per{' '}
        {isPricePerPerson ? 'person' : 'package'}
      </StyledPrice>
      <StyledButton to={url} alt={true} arrow={true}>
        View Details & Book
      </StyledButton>
    </StyledInner>
  </StyledMegaMenuSpaCta>
);

export default MegaMenuSpaCta;
